import { render } from "./BaseActionBtn.vue?vue&type=template&id=eba5de80&scoped=true"
import script from "./BaseActionBtn.vue?vue&type=script&lang=js"
export * from "./BaseActionBtn.vue?vue&type=script&lang=js"

import "./BaseActionBtn.vue?vue&type=style&index=0&id=eba5de80&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eba5de80"]])

export default __exports__